var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 511.469,
    height: 512,
    viewBox: "0 0 511.469 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OUR_PRODUCTS",
    "data-name": "OUR PRODUCTS",
    transform: "translate(-0.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2205",
    "data-name": "Group 2205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2204",
    "data-name": "Group 2204"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    width: 30.02,
    height: 57.03,
    transform: "translate(258.3)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2207",
    "data-name": "Group 2207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    "data-name": "Group 2206"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1943",
    "data-name": "Rectangle 1943",
    width: 57.032,
    height: 30.011,
    transform: "translate(312.403 63.381) rotate(-69.88)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    "data-name": "Group 2209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2208",
    "data-name": "Group 2208"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1944",
    "data-name": "Rectangle 1944",
    width: 30.011,
    height: 57.032,
    transform: "translate(186.431 20.171) rotate(-20.12)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2211",
    "data-name": "Group 2211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2210",
    "data-name": "Group 2210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19426",
    "data-name": "Path 19426",
    d: "M411.026,130.064H298.381l24.031,44.811H435.057Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2213",
    "data-name": "Group 2213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2212",
    "data-name": "Group 2212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19427",
    "data-name": "Path 19427",
    d: "M135.591,130.064,111.56,174.875H224.2l24.032-44.811Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    "data-name": "Group 2215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2214",
    "data-name": "Group 2214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19428",
    "data-name": "Path 19428",
    d: "M304.454,204.89,273.308,146.8,242.163,204.89H130.549v70.074c13.006-6.983,33.2-13.737,62.611-13.737,32.226,0,52.806,8.824,65.142,17.288a69.309,69.309,0,0,1,9.755,8.064h60.55a46.68,46.68,0,0,1,39.089,21.19l48.353-33.3.02-.02V204.89Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    "data-name": "Group 2217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    "data-name": "Group 2216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19429",
    "data-name": "Path 19429",
    d: "M490.664,257.576c-22.081,2.711-45.162,27.594-52.2,36.948L437,296.485,416.068,310.9l-41.14,28.334a44.283,44.283,0,0,1-.961,5.173A46.769,46.769,0,0,1,328.6,380H227.746V349.981H328.605A16.708,16.708,0,0,0,345.279,332.6c-.367-9.029-8.122-16.009-17.159-16.009H252.438l-3.852-6.813c-1.491-1.971-15.277-18.539-55.427-18.539a135.991,135.991,0,0,0-22.057,1.693,78.74,78.74,0,0,0-38.189,17.933l-2.364,2.015-7.7,7.874,66.693,124.01H343.973l100.159-73.146,67.6-108.173C505.152,258.5,498.418,256.635,490.664,257.576Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2219",
    "data-name": "Group 2219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    "data-name": "Group 2218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19430",
    "data-name": "Path 19430",
    d: "M77.273,299.386.265,339.6,90.279,512,169.4,470.7Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurProducts);
export default __webpack_public_path__ + "static/media/our_products.7476d324ff57a01d37cbc12351ae7ddc.svg";
export { ForwardRef as ReactComponent };